import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import environment from '@/modules/perseo-billing/environments/environment';

const { GIFTCARD_URL } = environment;

export async function deleteGiftCard(): Promise<{ data: HttpCartDto }> {
  const response = await httpClient.delete(GIFTCARD_URL, {
    timeout: 15000
  });
  return Promise.resolve(response);
}
